export default __webpack_public_path__ + "static/media/new2.ee61212d.png";